*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: block;
}

.header {
  user-select: none;

  padding: 8px 8px 4px;

  font-size: 12px;
  font-weight: 600;
  color: var(--wui-color-text-tertiary, rgb(27 27 27 / 0.35));
}
